import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import CheckEligibility from '../../services/check-eligibility.service';
import { AnalyticsService } from '../../services/analytics.service';
import axios from 'axios';
import './form-check-eligibility-platinum-optimum-bank-account.component.scss';
import * as $ from 'jquery';
var FormCheckEligibilityPlatinumOptimumBankAccount = /** @class */ (function (_super) {
    tslib_1.__extends(FormCheckEligibilityPlatinumOptimumBankAccount, _super);
    function FormCheckEligibilityPlatinumOptimumBankAccount(element, analyticsService) {
        var _this = _super.call(this, element) || this;
        _this.valueClient = false;
        _this.valueFormValid = false;
        _this.valueNationality = "";
        _this.valueResidence = "";
        _this.valuePrivateClient = false;
        _this.valueModalId = "";
        _this.valueDateOfBirth = "";
        return _this;
    }
    FormCheckEligibilityPlatinumOptimumBankAccount.prototype.init = function () {
        this.checkEligibility = new CheckEligibility();
        this.form = this.element.querySelector('form');
        this.radioPrivate = Array.from(this.element.querySelectorAll('.js-private-banking-client__radio'));
        this.radioClient = Array.from(this.element.querySelectorAll('.js-using-international-products__radio'));
        this.checkboxSameNationality = this.element.querySelector('.js-same-as-nationality');
        this.dropdownNationality = this.element.querySelector('.js-nationality');
        this.dropdownResidence = this.element.querySelector('.js-residence');
        this.inputDateOfBirth = this.element.querySelector('.js-date-of-birth');
        this.buttonSubmit = Array.from(this.element.querySelectorAll('.js-check-eligibility-submit__button'));
        this.containerFields = this.element.querySelector('.form__fields--container');
        this.containerNote = this.element.querySelector('.apply-now__note');
        this.containerButtons = this.element.querySelector('.apply-now__buttons');
        this.containerNationality = this.element.querySelector('div.form-check-eligibility-platinum-optimum-bank-account__group[data-group-name=nationality]');
        this.containerUsingProducts = this.element.querySelector('div.form-check-eligibility-platinum-optimum-bank-account__group[data-group-name=using_international_products]');
        this.containerPrivateClient = this.element.querySelector('div.form-check-eligibility-platinum-optimum-bank-account__group[data-group-name=private_client]');
        this.containerThankYou = this.element.querySelector('.form__thankyou--container');
        this.containerInvalidAge = this.element.querySelector('.js-invalid-age-container');
        this.containerInvalidLocation = this.element.querySelector('.js-invalid-location-container');
        this.containerInvalidExclusive = this.element.querySelector('.js-invalid-exclusive-container');
        this.containerValid = this.element.querySelector('.js-valid-container');
        this.containerValidExisting = this.element.querySelector('.js-valid-existing-container');
        this.containerValidOffshore = this.element.querySelector('.js-valid-allowedoffshore-container');
        this.containerValidExpat = this.element.querySelector('.js-valid-allowedexpat-container');
        this.containerValidOther = this.element.querySelector('.js-valid-allowedother-container');
        this.containerLoader = this.element.querySelector('.form__loader--container');
        this.valueModalId = this.element.closest('.js-apply-now-modal').getAttribute('id');
        this.containerModal = this.element.closest('.form-container');
        this.closeButton = this.containerModal.querySelector('.js-apply-now-modal-close');
        this.valuesJson = {
            operation: "open",
            category: "individual",
            leadType: "",
            leadCTA: "CHECK ELIGIBILITY",
            leadStatus: "Open",
            eligibilityFormId: "",
            eligibilityCTA: "",
            clientWIN: "N",
            sbgPrivateClient: "N",
            yachtCrew: "N",
            referralCode: "",
            coN: "",
            coR: "",
            doB: "",
            countryEligibilty: "",
            productName: "",
            pageUrl: ""
        };
    };
    FormCheckEligibilityPlatinumOptimumBankAccount.prototype.bindEvents = function () {
        var _this = this;
        // radio buttons- private client
        this.radioPrivate.map(function (item) { return item.addEventListener('click', function (event) {
            var element = event.target;
            _this.containerNationality.classList.add('form-check-eligibility-platinum-optimum-bank-account--hidden');
            _this.containerUsingProducts.classList.add('form-check-eligibility-platinum-optimum-bank-account--hidden');
            _this.containerNote.classList.add('form-check-eligibility-platinum-optimum-bank-account--hidden');
            _this.containerButtons.classList.add('form-check-eligibility-platinum-optimum-bank-account--hidden');
            _this.valueClient = false;
            _this.valueFormValid = false;
            _this.valuePrivateClient = false;
            if (element.value == "yes") {
                _this.valuesJson.sbgPrivateClient = 'Y';
                _this.valuePrivateClient = true;
                _this.containerUsingProducts.classList.remove('form-check-eligibility-platinum-optimum-bank-account--hidden');
                _this.containerNationality.classList.remove('form-check-eligibility-platinum-optimum-bank-account--hidden');
            }
            else {
                _this.valuesJson.sbgPrivateClient = 'N';
                _this.valuePrivateClient = false;
                _this.containerNote.classList.remove('form-check-eligibility-platinum-optimum-bank-account--hidden');
                _this.containerButtons.classList.remove('form-check-eligibility-platinum-optimum-bank-account--hidden');
            }
            _this.containerNote.classList.remove('form-check-eligibility-platinum-optimum-bank-account--hidden');
            _this.containerButtons.classList.remove('form-check-eligibility-platinum-optimum-bank-account--hidden');
        }); });
        // radio buttons - using products
        this.radioClient.map(function (item) { return item.addEventListener('click', function (event) {
            var element = event.target;
            _this.containerNationality.classList.add('form-check-eligibility-platinum-optimum-bank-account--hidden');
            if (element.value == "no") {
                _this.valuesJson.clientWIN = 'N';
                _this.valueClient = false;
                _this.valueFormValid = false;
                _this.containerNationality.classList.remove('form-check-eligibility-platinum-optimum-bank-account--hidden');
            }
            else {
                _this.valuesJson.clientWIN = 'Y';
                _this.valueClient = true;
                _this.valueFormValid = true;
            }
        }); });
        // dropdown nationality
        this.dropdownNationality.addEventListener('change', function (event) {
            var element = event.target;
            _this.valueNationality = element.value;
            _this.valuesJson.coN = element.value;
        });
        // dropdown residence
        this.dropdownResidence.addEventListener('change', function (event) {
            var element = event.target;
            if (!_this.checkboxSameNationality.checked) {
                _this.valueResidence = element.value;
            }
            else {
                $(_this.checkboxSameNationality)[0].checked = false;
            }
            _this.valuesJson.coR = element.value;
        });
        // check same nationality
        this.checkboxSameNationality.addEventListener('click', function (event) {
            var element = event.target;
            var formField = _this.dropdownResidence;
            var formGroup = _this.dropdownResidence.closest('.form__group');
            if (element.checked) {
                _this.valueResidence = _this.valueNationality;
                formField.classList.remove('form__input--required');
                formGroup.classList.remove('form__group--error');
                _this.dropdownResidence.selectedIndex = 0;
            }
            else {
                formField.classList.add('form__input--required');
                formGroup.classList.add('form__group--error');
            }
            _this.valuesJson.coR = _this.valueNationality;
        });
        // date of birth keypress check
        this.inputDateOfBirth.addEventListener('keyup', function (event) {
            var component = event.target;
            if (component.value) {
                var value = component.value;
                _this.valueDateOfBirth = value;
                var result = _this.checkEligibility.isBeforeToday(value, component);
                _this.valuesJson.doB = value;
            }
        });
        // date of birth onchange check
        this.inputDateOfBirth.addEventListener('change', function (event) {
            var component = event.target;
            if (component.value) {
                var value = component.value;
                _this.valueDateOfBirth = value;
                ;
                var result = _this.checkEligibility.isBeforeToday(value, component);
                _this.valuesJson.doB = value;
            }
        });
        // submit button
        this.buttonSubmit.map(function (item) { return item.addEventListener('click', function (event) {
            var formModal = _this.element.closest('.js-apply-now-modal');
            _this.valueModalId = formModal.getAttribute('id');
            if (_this.valuePrivateClient) {
                // already standard bank client
                if (_this.valueFormValid) {
                    _this.valuesJson.leadType = "IPB Sales";
                    _this.valuesJson.countryEligibilty = "CallMeBack";
                    _this.applyFilters('callmeback', _this.valueModalId);
                }
                else {
                    var formFields = _this.form.querySelectorAll('input, select');
                    var validation = _this.validationService.validateEnterprise(formFields);
                    var validDateOfBirth = _this.checkEligibility.isBeforeToday(_this.valueDateOfBirth, _this.inputDateOfBirth);
                    if (validation.valid && validDateOfBirth) {
                        var equalAfricanCountries = _this.checkEligibility.equalAfricanCountries(_this.valueNationality, _this.valueResidence);
                        var equalOffshore = _this.checkEligibility.equalOffshore(_this.valueNationality, _this.valueResidence);
                        var allowedExpat = _this.checkEligibility.allowCountryExPats(_this.valueNationality, _this.valueResidence);
                        var allowedDisq = _this.checkEligibility.allowCountryDisq(_this.valueNationality, _this.valueResidence);
                        var allowedOther = _this.checkEligibility.allowCountryOther(_this.valueNationality, _this.valueResidence);
                        if (_this.checkEligibility.validateDOB(_this.inputDateOfBirth.value)) {
                            // equal valid african countries 
                            if (equalAfricanCountries == true) {
                                _this.valuesJson.leadType = "LMM";
                                _this.valuesJson.countryEligibilty = "AllowedCountryAfrica";
                                _this.valuesJson.eligibilityCTA = "Apply Now";
                                _this.applyFilters('apply', _this.valueModalId);
                            }
                            else {
                                // equal valid offshore countries
                                if (equalOffshore == true) {
                                    _this.valuesJson.leadType = "LMM";
                                    _this.valuesJson.countryEligibilty = "AllowedCountryOffshore";
                                    _this.valuesJson.eligibilityCTA = "Apply Now";
                                    _this.applyFilters('apply', _this.valueModalId);
                                }
                                else {
                                    // invalid nationality but valid expat
                                    if (allowedExpat == true) {
                                        _this.valuesJson.leadType = "LMM";
                                        _this.valuesJson.countryEligibilty = "AllowedCountryExpat";
                                        _this.valuesJson.eligibilityCTA = "Apply Now";
                                        _this.applyFilters('apply', _this.valueModalId);
                                    }
                                    else {
                                        // disqualified nationality
                                        if (allowedDisq == true) {
                                            _this.containerInvalidLocation.classList.add('active');
                                            _this.checkEligibility.changeButtons('contactus', _this.valueModalId);
                                            _this.analyticsService.dtmFormComplete('complete', '', true, 'Not Eligible');
                                        }
                                        else {
                                            // CON != COR
                                            if (allowedOther == true) {
                                                _this.valuesJson.leadType = "LMM";
                                                _this.valuesJson.countryEligibilty = "AllowedCountryOther";
                                                _this.valuesJson.eligibilityCTA = "Apply Now";
                                                _this.applyFilters('apply', _this.valueModalId);
                                            }
                                            else {
                                                _this.containerInvalidLocation.classList.add('active');
                                                _this.checkEligibility.changeButtons('contactus', _this.valueModalId);
                                                _this.analyticsService.dtmFormComplete('complete', '', true, 'Not Eligible');
                                            }
                                        }
                                        // if(allowedOther == true){
                                        // 	this.valuesJson.leadType = "LMM";
                                        // 	this.valuesJson.countryEligibilty = "AllowedCountryOther";
                                        // 	this.valuesJson.eligibilityCTA = "Apply Now";
                                        // 	this.applyFilters('apply', this.valueModalId);
                                        // }else{
                                        // 	// failed
                                        // 	this.containerInvalidLocation.classList.add('active');	
                                        // 	this.checkEligibility.changeButtons('contactus', this.valueModalId);
                                        // 	this.analyticsService.dtmFormComplete('complete', '', true, 'Not Eligible');
                                        // }
                                    }
                                }
                            }
                        }
                        else {
                            _this.containerInvalidAge.classList.add('active');
                            _this.checkEligibility.changeButtons('contactus', _this.valueModalId);
                            _this.analyticsService.dtmFormComplete('complete', '', true, 'Not Eligible');
                        }
                        _this.containerThankYou.classList.add('active');
                        _this.containerFields.classList.add('hidden');
                    }
                }
            }
            else {
                _this.containerInvalidExclusive.classList.add('active');
                _this.containerThankYou.classList.add('active');
                _this.containerFields.classList.add('hidden');
                _this.checkEligibility.changeButtons('contactus', _this.valueModalId);
            }
        }); });
        // close button - reset form
        this.closeButton.addEventListener('click', function (event) {
            _this.containerButtons.classList.add('form-check-eligibility-platinum-optimum-bank-account--hidden');
            _this.containerNote.classList.add('form-check-eligibility-platinum-optimum-bank-account--hidden');
            _this.containerUsingProducts.classList.add('form-check-eligibility-platinum-optimum-bank-account--hidden');
            _this.containerNationality.classList.add('form-check-eligibility-platinum-optimum-bank-account--hidden');
            _this.containerValid.classList.remove('active');
            _this.containerValidExisting.classList.remove('active');
            _this.containerInvalidAge.classList.remove('active');
            _this.containerInvalidExclusive.classList.remove('active');
            _this.containerInvalidLocation.classList.remove('active');
            _this.containerValidOffshore.classList.remove('active');
            _this.containerValidOffshore.classList.remove('active');
            _this.containerValidExpat.classList.remove('active');
            _this.containerValidExpat.classList.remove('active');
            _this.containerValidOther.classList.remove('active');
            _this.containerValidOther.classList.remove('active');
            _this.containerValid.classList.add('form-check-eligibility-platinum-optimum-bank-account--hidden');
            _this.containerValidExisting.classList.add('form-check-eligibility-platinum-optimum-bank-account--hidden');
            _this.containerInvalidAge.classList.add('form-check-eligibility-platinum-optimum-bank-account--hidden');
            _this.containerInvalidExclusive.classList.add('form-check-eligibility-platinum-optimum-bank-account--hidden');
            _this.containerInvalidLocation.classList.add('form-check-eligibility-platinum-optimum-bank-account--hidden');
            _this.containerValidOffshore.classList.add('form-check-eligibility-platinum-optimum-bank-account--hidden');
            _this.containerValidOffshore.classList.add('form-check-eligibility-platinum-optimum-bank-account--hidden');
            _this.containerValidExpat.classList.add('form-check-eligibility-platinum-optimum-bank-account--hidden');
            _this.containerValidExpat.classList.add('form-check-eligibility-platinum-optimum-bank-account--hidden');
            _this.containerValidOther.classList.add('form-check-eligibility-platinum-optimum-bank-account--hidden');
            _this.containerValidOther.classList.add('form-check-eligibility-platinum-optimum-bank-account--hidden');
            var selectResidence = _this.element.querySelector('select.js-residence');
            selectResidence.classList.add('form__input--required');
        });
        $(document).on('click', "a.js-apply-now-modal-open[data-modal='" + this.valueModalId + "']", function (event) {
            var element = event.target;
            var parentAttribute = "";
            if (element.closest('.product-offering-exchange__button')) {
                parentAttribute = element.closest('.product-offering-exchange__button').getAttribute('data-buttonclass');
            }
            if (element.closest('.comparison-exchange__product__button')) {
                parentAttribute = element.closest('.comparison-exchange__product__button').getAttribute('data-buttonclass');
            }
            if (element.closest('.detailed-product-card-exchange__buttons-js')) {
                parentAttribute = element.closest('.detailed-product-card-exchange__buttons-js').getAttribute('data-buttonclass');
            }
            if (parentAttribute === 'Eligibility') {
                var type = $(element).attr('data-productname');
                var modal = $(element).attr('data-modal');
                var data = $(element).attr('data-text');
                var dataArray = data.split(" | ");
                var dataNewFormName = "checkeligibility | wealth bank accounts | " + type;
                _this.form.setAttribute('data-frmcontainer', dataNewFormName);
                _this.valuesJson.pageUrl = window.location.href;
                if (type) {
                    _this.valuesJson.productName = type;
                }
                if (modal) {
                    _this.valuesJson.eligibilityFormId = modal;
                }
                _this.formstart();
                // APPLICATION ID
                var valueProductID = $(element).closest('.js-product-id').attr('data-productid');
                console.log('Modal ID', modal);
                console.log('Product ID', valueProductID);
                _this.checkEligibility.checkApplicationID(modal, valueProductID, dataNewFormName, type);
            }
            _this.formstart();
        });
    };
    FormCheckEligibilityPlatinumOptimumBankAccount.prototype.applyFilters = function (type, modalId) {
        var containerLoader = this.containerLoader;
        var containerValidExisting = this.containerValidExisting;
        var containerThankyou = this.containerThankYou;
        var containerFields = this.containerFields;
        var containerValid = this.containerValid;
        var containerValidOffshore = this.containerValidOffshore;
        var containerValidExpat = this.containerValidExpat;
        var containerValidOther = this.containerValidOther;
        var checkEligibility = this.checkEligibility;
        containerFields.classList.add('hidden');
        containerLoader.classList.add('active');
        // variables
        var response = 'invalid';
        // fields
        var operation = this.valuesJson.operation;
        var category = this.valuesJson.category;
        var leadType = this.valuesJson.leadType;
        var leadCTA = this.valuesJson.leadCTA;
        var leadStatus = this.valuesJson.leadStatus;
        var eligibilityCTA = this.valuesJson.eligibilityCTA;
        var eligibilityFormId = this.valuesJson.eligibilityFormId;
        var clientWIN = this.valuesJson.clientWIN;
        var sbgPrivateClient = this.valuesJson.sbgPrivateClient;
        var yachtCrew = this.valuesJson.yachtCrew;
        var referralCode = this.valuesJson.referralCode;
        var coN = this.valuesJson.coN;
        var coR = this.valuesJson.coR;
        var doB = this.valuesJson.doB;
        var countryEligibilty = this.valuesJson.countryEligibilty;
        var productName = this.valuesJson.productName;
        var pageUrl = this.valuesJson.pageUrl;
        var applicationID = this.checkEligibility.applicationID;
        var productID = this.checkEligibility.applicationProductID;
        // build string
        var postData = '';
        if (operation) {
            postData += 'operation=' + operation + '&';
        }
        if (category) {
            postData += 'category=' + category + '&';
        }
        if (leadType) {
            postData += 'leadType=' + leadType + '&';
        }
        if (leadCTA) {
            postData += 'leadCTA=' + leadCTA + '&';
        }
        if (leadStatus) {
            postData += 'leadStatus=' + leadStatus + '&';
        }
        if (eligibilityFormId) {
            postData += 'eligibilityFormId=' + eligibilityFormId + '&';
        }
        if (eligibilityCTA) {
            postData += 'eligibilityCTA=' + eligibilityCTA + '&';
        }
        if (clientWIN) {
            postData += 'clientWIN=' + clientWIN + '&';
        }
        if (sbgPrivateClient) {
            postData += 'sbgPrivateClient=' + sbgPrivateClient + '&';
        }
        if (yachtCrew) {
            postData += 'yachtCrew=' + yachtCrew + '&';
        }
        if (referralCode) {
            postData += 'referralCode=' + referralCode + '&';
        }
        if (coN) {
            postData += 'coN=' + coN + '&';
        }
        if (coR) {
            postData += 'coR=' + coR + '&';
        }
        if (doB) {
            var date = new Date(doB);
            var DD = (date.getDate() <= 9 ? '0' : '') + date.getDate();
            var MM = (date.getMonth() < 9 ? '0' : '') + (date.getMonth() + 1);
            var YYYY = date.getFullYear();
            var value = DD + '/' + MM + '/' + YYYY;
            postData += 'doB=' + value + '&';
        }
        if (countryEligibilty) {
            postData += 'countryEligibilty=' + countryEligibilty + '&';
        }
        if (productName) {
            postData += 'productName=' + productName + '&';
        }
        if (pageUrl) {
            postData += 'pageUrl=' + pageUrl + '&';
        }
        if (applicationID) {
            postData += 'appID=' + applicationID + '&';
        }
        if (productID) {
            postData += 'productID=' + productID + '&';
        }
        // config
        var analyticsService = new AnalyticsService();
        var url = "/services/SubmitWINLead.jsp";
        var config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // service
        axios.post(url, postData, config).then(function (response) {
            if (response.data === 'invalid') {
                analyticsService.dtmRecordSiteError('noerrorcode|invalid fields|' + url);
                containerLoader.classList.remove('active');
                containerFields.classList.remove('hidden');
                checkEligibility.changeButtons(type, modalId, '');
            }
            else {
                var responseData = response.data;
                containerLoader.classList.remove('active');
                if (type === 'callmeback') {
                    containerValidExisting.classList.add('active');
                    containerThankyou.classList.add('active');
                    containerFields.classList.add('hidden');
                }
                else if (type === 'apply') {
                    if (countryEligibilty === 'AllowedCountryOffshore') {
                        containerValidOffshore.classList.add('active');
                    }
                    else if (countryEligibilty === 'AllowedCountryExpat') {
                        containerValidExpat.classList.add('active');
                    }
                    else if (countryEligibilty === 'AllowedCountryOther') {
                        containerValidOther.classList.add('active');
                    }
                    else {
                        containerValid.classList.add('active');
                    }
                }
                checkEligibility.changeButtons(type, modalId, responseData);
                analyticsService.dtmFormCompleteEligibility('complete', responseData.leadID, true, 'Eligible');
            }
        }).catch(function (response) {
            // service failed
            analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
        });
    };
    // reset form
    FormCheckEligibilityPlatinumOptimumBankAccount.prototype.resetForm = function () {
        if (this.form) {
            this.form.reset();
            var formContainerLoader = this.element.querySelector('.form__loader--container');
            var formContainerFields = this.element.querySelector('.form__fields--container');
            var formContainerThankyou = this.element.querySelector('.form__thankyou--container');
            formContainerThankyou.classList.remove('active');
            formContainerFields.classList.remove('hidden');
        }
    };
    FormCheckEligibilityPlatinumOptimumBankAccount.prototype.formstart = function () {
        var dataNewFormName = "checkeligibility | wealth bank accounts | " + this.valuesJson.productName;
        this.analyticsService.dtmFormNameUpdate(dataNewFormName);
        this.analyticsService.dtmAllowFormRefresh();
    };
    return FormCheckEligibilityPlatinumOptimumBankAccount;
}(Base));
export { FormCheckEligibilityPlatinumOptimumBankAccount };



//////////////////
// WEBPACK FOOTER
// ./components/form-check-eligibility-platinum-optimum-bank-account/form-check-eligibility-platinum-optimum-bank-account.component.ts
// module id = 307
// module chunks = 0